import { defineMessage, type MessageDescriptor } from 'react-intl';

/**
 * Shown when a plan or step affects nothing. Shared by the action card and the
 * canvas step row so both surfaces stay on one string and one message id.
 */
export const emptyBlastRadiusSummaryMessage: MessageDescriptor = defineMessage({
	id: 'ai-mate-jira-admin-agent.jira-admin-agent.canvas.blast-radius.empty.summary.non-final',
	defaultMessage: 'No spaces, boards, filters or dashboards are impacted.',
	description: 'Message shown when no entities are affected by the changes.',
});
